import CustomCheckbox from "../../../../../../components/CustomCheckbox";

const FlowSelection = ({ selectedTypes, setSelectedTypes }) => {
  const flowType = selectedTypes.find((item) => item.key === "flow") || {};

  const handleLangClick = (lang) => {
    setSelectedTypes((prev) =>
      prev.map((item) => {
        if (item.key === "flow") {
          return { ...item, [lang]: !item[lang] };
        }
        return item;
      })
    );
  };

  const options = [
    { key: "kor", label: "한글" },
    { key: "eng", label: "영어" },
  ];

  return (
    <div style={{ display: "flex", gap: "30px", fontSize: "16px" }}>
      {options.map((opt) => (
        <div
          key={opt.key}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <CustomCheckbox
            checked={!!flowType[opt.key]}
            onChange={() => handleLangClick(opt.key)}
            disabled={setSelectedTypes === undefined}
          />
          {opt.label}
        </div>
      ))}
    </div>
  );
};

export default FlowSelection;
